import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Clock, MessageSquare, Lock, Bot, ChevronLeft } from 'lucide-react';
import { supabase } from '../../lib/supabase';
import './Participant.css';

export default function WelcomePage() {
  const { agentId } = useParams();
  const navigate = useNavigate();

  const [agent, setAgent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [starting, setStarting] = useState(false);

  useEffect(() => {
    supabase.from('agents').select('*').eq('id', agentId).single()
      .then(({ data, error }) => {
        if (data) setAgent({ ...data, questionCount: data.question_count });
        else setNotFound(true);
        setLoading(false);
      });
  }, [agentId]);

  const handleStart = async () => {
    setStarting(true);
    const { data, error } = await supabase.from('sessions').insert([{
      agent_id: agentId,
      status: 'in-progress',
      messages: [],
      analysis: null,
      duration_minutes: null,
    }]).select().single();

    if (data) navigate(`/interview/${agentId}/chat?session=${data.id}`);
    else setStarting(false);
  };

  // تحميل
  if (loading) return (
    <div className="participant-bg">
      <div className="p-card" style={{ textAlign: 'center', padding: '3rem' }}>
        <div className="spinner" style={{ margin: '0 auto 1rem', width: '28px', height: '28px' }} />
        <p style={{ color: 'var(--brown-muted)', fontSize: '14px' }}>جاري التحميل...</p>
      </div>
    </div>
  );

  // غير موجود
  if (notFound) return (
    <div className="participant-bg">
      <div className="p-card" style={{ textAlign: 'center', padding: '2rem' }}>
        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>⚠️</div>
        <h2 style={{ color: 'var(--brown)', marginBottom: '0.5rem' }}>رابط المقابلة غير صالح</h2>
        <p style={{ color: 'var(--brown-muted)' }}>يبدو أن هذا الرابط منتهي أو غير صحيح</p>
      </div>
    </div>
  );

  return (
    <div className="participant-bg">
      <div className="p-card animate-in">
        <div className="p-logo"><span>🍔</span><span>هنقرستيشن</span></div>
        <h1 className="p-title">مرحباً بك في مقابلة تجربة المستخدم</h1>
        <p className="p-desc">
          نريد معرفة رأيك في <strong>{agent.name}</strong> لتطوير تجربتنا وجعلها أفضل لك ولجميع المستخدمين.
        </p>
        <div className="info-list">
          <div className="info-row"><div className="info-icon"><Clock size={14} /></div><span>مدة المقابلة تقريباً <strong>8–12 دقيقة</strong></span></div>
          <div className="info-row"><div className="info-icon"><MessageSquare size={14} /></div><span>المقابلة نصية بالكامل، لا يوجد فيديو أو صوت</span></div>
          <div className="info-row"><div className="info-icon"><Lock size={14} /></div><span>إجاباتك سرية وتُستخدم فقط لأغراض البحث الداخلي</span></div>
          <div className="info-row"><div className="info-icon"><Bot size={14} /></div><span>ستتحدث مع مساعد ذكاء اصطناعي متخصص بالأبحاث</span></div>
        </div>
        <button className="btn btn-primary btn-lg btn-full" onClick={handleStart} disabled={starting}>
          {starting ? 'جاري التحضير...' : 'ابدأ المقابلة الآن'}
          {!starting && <ChevronLeft size={18} />}
        </button>
        <p className="p-privacy">بالنقر على "ابدأ" أنت توافق على أن إجاباتك ستُستخدم لأغراض تحسين المنتج</p>
      </div>
    </div>
  );
}
